"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemInventoryFilter = itemInventoryFilter;
/**
 * Applies the standard inventory filters to the given item inventory object.
 */
function itemInventoryFilter(inv, filters) {
  if (!filters.include_zero_qty && inv.qty === 0) return false;
  if (filters.facility_id && inv.facility_id !== filters.facility_id) return false;
  if (filters.work_order_item_ids && !filters.work_order_item_ids.includes(inv.work_order_item_id)) return false;
  if (filters.work_order_item_id && inv.work_order_item_id !== filters.work_order_item_id) return false;
  if (filters.operation_ids !== undefined) {
    if (filters.operation_ids.length === 0) return false;
  } else if (filters.operation_id !== undefined) {
    if (filters.operation_id !== inv.operation_id) return false;
  } else if (filters.include_wip) {
    // Do nothing, apply no filter here
  } else if (filters.only_wip) {
    if (inv.operation_id <= 0) return false;
  } else {
    if (inv.operation_id !== 0) return false;
  }
  return true;
}